import React, { Component } from 'react';

export default class ServiceStatement extends Component {
	render() {
		return (
			<div>
				<h1 style={{justifyContent:"center" , display:"flex"}}>توافقنامه سطح خدمت</h1>
				<div className="TabContent">
					<h3>مقدمه</h3>
					<p>
						این سازمان 34 خدمت اصلی / زیرخدمت را به مخاطبین ارائه می دهد و لازم به ذکر است که فهرست کامل آن
						در منوی اصلی پورتال  با عنوان خدمات الکترونیک " شناسنامه خدمات " قرار دارد.
					</p>
					<h3>هدف</h3>

					<p>
						هدف از توافقنامه سطح خدمت این است که به منظور ارائه با کیفیت خدمت ارائه شده توسط سازمان جنگلها
						مراتع وآبخیزداری کشور، کیفیت تحویل ارائه خدمت برای خدمت گیرندگان مورد توافق قرار گیرد
					</p>

					<h3>مسئولیت</h3>
					<p>
						قوانین و مقرراتی را که به این سازمان اجازه می دهد خدمت را ارائه دهد در بخش قوانین و مقررات
						شناسنامه خدمات موجود می باشد
					</p>

					<h3>تعهدات متقابل خدمت گیرنده و دستگاه اجرایی</h3>
					<p>
						متقاضی دریافت خدمت مکلف است مدارک خود را تنها از طریق سامانه میز خدمت الکترونیکی / دفتر پیشخوان/
						منطبق با توضیحات درج شده در شناسنامه خدمت مورد نظر به این دستگاه ارائه نماید
					</p>
					<p>
						موارد مربوط به زمان انجام خدمت، تعداد مرتبه مراجعه حضوری متقاضی، نحوه دسترسی و زمانهای دسترسی به
						خدمت و کلیه جزئیات خدمت بصورت کامل در شناسنامه خدمات ذکر شده است
					</p>

					<h3>هزینه ها و پرداخت ها</h3>
					<p>
						توافقات مربوط به هزینه ها و پرداختها منطبق با اطلاعات ثبت شده در شناسنامه خدمات دریافت خواهد شد
					</p>

					<h3>دوره عملکرد</h3>
					<p>
						این توافقنامه سطح خدمت تا زمانی که لیست خدمات توسط سازمان جنگلها مراتع وآبخیزداری کشور ارائه می
						شود اعتبار خواهد داشت.
					</p>

					<h3> لازم به ذکر است:</h3>
					<p>
						1- تارنمای سازمان جنگلها مراتع وآبخیزداری کشور امکان ثبت درخواستها و سوالات کاربران گرامی
						ارتباط" تماس با ما" را دارد. در این قسمت شما میتوانید بصورت تمام وقت با حوزه های مختلف از منوی
						برقرار نمایید
					</p>
					<p>
						2- روی هرکدام از عناوین خدمات مندرج در میز خدمت نیز شماره تماس ، پیگیری خدمت ، ثبت شکایت ، نظر
						سنجی و پیشنهاد قراردارد که پس از ثبت درخواستها از طریق پیامک به خدمت گیرنده اطلاع رسانی می گردد.
					</p>
					<p>
						3- تارنمای سازمان جنگلها مراتع وآبخیزداری کشور بصورت تمام وقت در دسترس کاربران گرامی بوده و در
						صورت بروز هرگونه اشکال ونقص فنی ، به کاربران اطلاع رسانی خواهد گردید .
					</p>
				</div>
			</div>
		);
	}
}
